import React from 'react';
import {MINUS_SIGN} from "../../../constants/text";
import {MaskedIcon} from "../../coloredIcons/MaskedIcon/MaskedIcon";
import {RULES_ANCHOR_IDS} from "../RulesSectionLink/RulesSectionLink";

const WarPhaseRules = () => {
  const coins = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/coins.png'}
    alt={'Монеты'}
    title={'Монеты'}
  />;
  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;
  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const size = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер'}
    title={'Размер отряда'}
  />;
  const sizeInc = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/size inc rect.png'}
    alt={'Рост размера'}
    title={'Рост размера'}
  />;
  const speed = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/speed.png'}
    alt={'Перемещение'}
    title={'Перемещение'}
  />;
  // Иконка полета — белый силуэт: на светлой странице правил перекрашиваем маской
  const flight = <MaskedIcon
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/fly.png'}
    alt={'Полет'}
    title={'Полет'}
  />;
  const mountain = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mountains/mountain_rock_1.862dc5c3.png'}
    alt={'Гора'}
    title={'Гора'}
  />;
  const unitEnemy = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;
  const shooting = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/shooting.png'}
    alt={'Стрельба'}
    title={'Стрельба'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const maneuver = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/maneuver_black.png'}
    alt={'Маневр'}
    title={'Маневр'}
  />;
  const dice = <img
    className={'policy-description-icon'}
    src={'/img/icons/dice.png'}
    alt={'Кость урона'}
    title={'Кость урона'}
  />;

  // Значки этапов: стоят перед подписью и в перечне этапов, и в заголовке
  // раздела каждого этапа. Декоративные — что это за этап, сказано текстом
  // рядом, поэтому скрыты от скринридеров
  const stageIcon = (src) => <img className={'rules-page_stage-icon'} src={src} alt={''} aria-hidden={'true'}/>;
  const recruitmentStageIcon = stageIcon('/img/icons/coins.png');
  const movementStageIcon = stageIcon('/img/icons/speed.png');
  const shootingStageIcon = stageIcon('/img/icons/shooting.png');
  const meleeStageIcon = stageIcon('/img/icons/barracks red.png');
  const maneuverStageIcon = stageIcon('/img/icons/maneuver_black.png');

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-war">
        <img
          className={'rules-page_title-icon'}
          src={'/img/icons/barracks red.png'}
          alt={''}
          aria-hidden={'true'}
        />
        Фаза Войны
      </h2>

      <div className="rules-page_section">
        <p>Фаза Войны разделена на 5 этапов, которые каждый игрок в свой ход проходит по порядку:</p>
        <ol>
          <li>{recruitmentStageIcon}Этап найма</li>
          <li>{movementStageIcon}Этап перемещения отрядов</li>
          <li>{shootingStageIcon}Этап стрельбы</li>
          <li>{meleeStageIcon}Этап ближнего боя</li>
          <li>{maneuverStageIcon}Этап маневра</li>
        </ol>
      </div>

      <div className="rules-page_section">
        <h2>{recruitmentStageIcon}1. Этап найма</h2>
        <p><b>Найм новых отрядов {unit}:</b> размещаются на незанятых казармах {barracks} гранью «1» вверх (то есть
          с размером, равным 1). Нанимать можно любое количество любых отрядов, заплатив соответствующую цену.</p>
        <p><b>Найм размера отрядов:</b> для отряда {unit}, расположенного на казарме {barracks}, за монеты {coins}
          можно увеличить размер {sizeInc}. Найм размера производится с кварталов {centralQuarter}{quarter} города,
          в котором расположена казарма — каждый найм размера увеличивает размер отряда на 1. Каждый квартал можно
          использовать для найма размера только 1 раз за фазу Войны (но снова можно будет в фазе Войны следующего
          раунда).</p>
        <p>
          <b>Пример:</b> у игрока в городе 3 квартала, в казарме стоит отряд d10 с размером 4. Игрок может заплатить
          3 раза (по одному разу с каждого квартала) за повышение размера отряда на 1, потратив в сумме монеты за все
          3 покупки и увеличив размер до 7.
        </p>
        <p><b>Улучшение отрядов:</b> отряд можно улучшить до более сильного типа за отдельную цену.</p>
        <p>
          Этап найма завершается автоматически, если сделать на нем нечего: у игрока нет работающих
          казарм {barracks} или монет {coins} не хватает ни на одно доступное действие.
        </p>
        <p>
          <b>Последний раунд партии:</b> новые отряды {unit} в нем уже не нанимаются — ни на казармах, ни у
          крысолюдов за снабжение на фермах. Но если отряд уже стоит на своей казарме {barracks} и она не
          заблокирована и не повреждена, ему в последнем раунде по-прежнему можно докупить размер {sizeInc} и
          улучшить тип. Если таких отрядов у игрока нет, этап найма в последнем раунде пропускается автоматически.
          Поэтому отряд, который должен что-то защитить или захватить в последнем раунде, нанимайте не позже
          предпоследнего раунда.
        </p>
        <p>
          Обычно последний раунд — 13-й. Если у партии свое число раундов (например, в локальной игре или миссии
          кампании), последним считается последний раунд этой партии.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>{movementStageIcon}2. Этап перемещения отрядов</h2>
        <p>Игрок может переместить {speed} любое количество своих отрядов {unit}. Отряд можно переместить на
          количество ячеек не более его дальности перемещения.</p>
        <ul>
          <li>В одной ячейке не может находиться более 1 отряда.</li>
          <li>Отряд можно переместить на 1 дополнительную ячейку за дополнительное снабжение.</li>
          <li>Перемещение отряда всегда останавливается, если он переместился в пустую ячейку (ячейку без строений и
            ключевых точек) — он не может продолжить перемещение в этой фазе, даже если не все очки перемещения
            израсходованы или есть неизрасходованное дополнительное снабжение.
          </li>
          <li>Отряды могут проходить по ячейкам с другими отрядами того же игрока, если хватает дальности перемещения
            — но не могут на них останавливаться. Свой отряд не меняет проходимость самой ячейки: сквозь пустую
            ячейку со своим отрядом пройти так же нельзя, как и сквозь пустую ячейку без отряда.
          </li>
        </ul>
        {/* Общее правило для всех фракций с летающими отрядами: правила фракций
            ссылаются сюда (RulesSectionLink), а не повторяют его */}
        <div id={RULES_ANCHOR_IDS.FLYING_UNITS}>
          <p><b>Летающие отряды {flight}</b> (у некоторых фракций) перемещаются по тем же правилам, но
            промежуточные ячейки пути для них ничего не ограничивают:</p>
          <ul>
            <li>отряд пролетает над горами {mountain}, отрядами противника {unitEnemy} и своими отрядами, чужими
              городами и пустыми ячейками;
            </li>
            <li>пустая ячейка не останавливает перемещение — летающий отряд может встать на любую ячейку в пределах
              дальности (+1 за дополнительное снабжение);
            </li>
            <li>закончить перемещение, как и у всех, можно только на ячейке без отряда и не на горе;</li>
            <li>море не входит в игровое поле — над ним не летают.</li>
          </ul>
          <p>Остальное у летающих отрядов как у всех: маневр (на 1 ячейку и не с пустой ячейки), пути снабжения и
            отмена перемещения. Ловушки гоблинов на пути полета не срабатывают — только на ячейке, где отряд
            закончил перемещение, и смежных ей.</p>
        </div>
      </div>

      <div className="rules-page_section">
        <h2>{shootingStageIcon}3. Этап стрельбы</h2>
        <p>
          Стрелять могут только отряды типа d4 (катапульты {shooting}) — подробные правила приведены в разделе
          «Правила для опытных игроков».
        </p>
      </div>

      <div className="rules-page_section">
        <h2>{meleeStageIcon}4. Этап ближнего боя</h2>
        <p>
          Если у игрока, который сейчас выполняет фазу Войны, есть отряды {unit}, смежные с отрядами противника, то и
          для этих отрядов игрока, и для этих отрядов противника:
        </p>
        <ul>
          <li>За каждый отряд бросается {dice} по 2 кости урона (кубик с гранями −3, −2, −1 (x2), 0 (x2)). Урон отряда =
            размер отряда {size} + сумма броска 2 костей урона.
          </li>
          <li>Если у отряда несколько смежных отрядов противника, приоритетной целью автоматически выбирается отряд с
            самым маленьким размером — остаток урона распределяется другим смежным отрядам противника по такому же
            принципу.
            <br/>Игрок также может самостоятельно поменять приоритетную цель.
          </li>
          <li>Урон {damage} все вовлеченные отряды наносят друг другу одновременно.</li>
          <li>Каждый отряд теряет размер, равный полученному урону. Если размер отряда уменьшается до 0, отряд
            считается уничтоженным и убирается с поля.
          </li>
          <li>Политики и особенности фракций могут накладывать дополнительные бонусы или штрафы на урон отряда.
            Суммарный положительный бонус не может превышать размер отряда: например, если отряд имеет размер 3, а
            суммарный бонус для него составляет +5, то учитывается только +3.
          </li>
        </ul>
        <p>
          <b>Примечание:</b> для оценки вероятного урона отряда перед боем можно использовать приблизительную формулу
          «урон = размер отряда {MINUS_SIGN} 2» (в среднем две кости урона дают около {MINUS_SIGN}2,3).
        </p>
      </div>

      <div className="rules-page_section">
        <h2>{maneuverStageIcon}5. Этап маневра</h2>
        <p>
          Если у отряда {unit} игрока, который сражался в ближнем бою {melee}, стрелял {shooting} или применял
          способность фракции на этапе Способностей (у фракций, где такой этап есть) в этой фазе войны, есть
          неизрасходованное дополнительное снабжение, он может переместиться {maneuver} за него на 1 ячейку — но не
          с пустой ячейки.
        </p>
      </div>
    </div>
  );
};

export default WarPhaseRules;
